import "./sizing.css";
import Form from "../../components/form/form";
import Joi from "joi-browser";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import {
    getAbsorptionDryerPressures,
    getAbsorptionDryerTemperature,
    getAbsorptionDryerConst,
} from "../../constants/sizing-constant";

import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";

export default class DryerAbsorptionHitterSizing extends Form {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            isLoading: false,
            suggestedModel: "",
            suggestedModelId: "",
            absorptionDryerPresures: [],
            absorptionDryerTemperatures: [],
            selectedAbsorptionDryerPresures: "0",
            selectedAbsorptionDryerPresuresVal: "0",
            selectedAbsorptionDryerTempreture: "0",
            selectedAbsorptionDryerTempretureVal: "0",
        };
    }
    state = {
        data: {
            InletFlowRate: "",
        },
        errors: {},
    };

    schema = {
        InletFlowRate: Joi.number().required().min(0).error(new Error("نرخ جریان ورودی از نوع عدد و اجباری است")),
    };

    componentDidMount() {
        this.setState({ absorptionDryerPresures: [...getAbsorptionDryerPressures()] });
        this.setState({ absorptionDryerTemperatures: [...getAbsorptionDryerTemperature()] });
    }

    handleabsorptionDryerCapacitySelect = (presures) => {
        if (presures) {
            this.setState({ selectedAbsorptionDryerPresures: presures.value }, () => { });
            this.setState({ selectedAbsorptionDryerPresuresVal: presures.calPressure }, () => {
                this.doSubmit();
            });
        }
    };

    handleAbsorptionDryerTemperatureSelect = (temperature) => {
        if (temperature) {
            this.setState({ selectedAbsorptionDryerTempreture: temperature.value }, () => { });
            this.setState({ selectedAbsorptionDryerTempretureVal: temperature.calTempreture }, () => {
                this.doSubmit();
            });
        }
    };

    doSubmit = async () => {
        try {
            if (this.state.selectedAbsorptionDryerPresures !== "0" && this.state.selectedAbsorptionDryerTempreture !== "0") {
                var AbsorptionDryerConst = getAbsorptionDryerConst(this.state.selectedAbsorptionDryerPresures, this.state.selectedAbsorptionDryerTempreture);
                var CorrectedFlow = AbsorptionDryerConst[0].CorrectionFactor * this.state.data.InletFlowRate;
                var DensityP1 = this.state.selectedAbsorptionDryerPresuresVal + 1.01325;
                var Densityp2 = DensityP1 * 100000;
                var Densityp3 = this.state.selectedAbsorptionDryerTempretureVal + 273.15;
                var DensityP4 = Densityp3 * 287.05;
                var DensityP5 = Densityp2 / DensityP4;

                var umsConst = 4 * 1.291 * this.state.data.InletFlowRate;
                var umsConst2 = 3600 * Math.PI * DensityP5;

                var ums900 = umsConst / (umsConst2 * 0.116964);
                var ums1500 = umsConst / (umsConst2 * 0.245025);
                var ums2000 = umsConst / (umsConst2 * 0.2916);
                var ums3000 = umsConst / (umsConst2 * 0.3844);
                var ums4000 = umsConst / (umsConst2 * 0.5625);
                var ums5000 = umsConst / (umsConst2 * 0.7396);
                var ums6000 = umsConst / (umsConst2 * 0.9025);
                var ums10000 = 0.25;

                var ts900 = 1.7 / ums900;
                var ts1500 = 1.5 / ums1500;
                var ts2000 = 2 / ums2000;
                var ts3000 = 2 / ums3000;
                var ts4000 = 2 / ums4000;
                var ts5000 = 2 / ums5000;
                var ts6000 = 2 / ums6000;
                var ts10000 = 5.5;

                var formula = [];
                formula.push({ fr: 900, u: ums900, t: ts900, model: "HHD 160", modelid: 289 });
                formula.push({ fr: 1500, u: ums1500, t: ts1500, model: "HHD 300", modelid: 290 });
                formula.push({ fr: 2000, u: ums2000, t: ts2000, model: "HHD 500", modelid: 291 });
                formula.push({ fr: 3000, u: ums3000, t: ts3000, model: "HHD 650", modelid: 292 });
                formula.push({ fr: 4000, u: ums4000, t: ts4000, model: "HHD 1000", modelid: 293 });
                formula.push({ fr: 5000, u: ums5000, t: ts5000, model: "HHD 1300", modelid: 294 });
                formula.push({ fr: 6000, u: ums6000, t: ts6000, model: "HHD 1600", modelid: 295 });
                formula.push({ fr: 10000, u: ums10000, t: ts10000, model: "Special Design", modelid: 296 });

                var result = formula.filter(m => m.fr >= CorrectedFlow && m.u >= 0.15 && m.u <= 0.3 && m.t >= 5);

                var ModelName = "";
                var ModelId = "";
                if (result && result.length) {
                    ModelName = result[0].model;
                    ModelId = result[0].modelid;
                } else {
                    ModelName = "Special Design";
                    ModelId = result[0].modelid;
                }
                this.setState({ suggestedModel: ModelName });
                this.setState({ suggestedModelId: ModelId });
            }
        } catch (ex) {
        }
    };

    render() {
        return (
            <section>
                <DropDownWhiteStyle items={this.state.absorptionDryerPresures} placeholder="فشار ورودی (برحسب psi - g)" onItemSelect={this.handleabsorptionDryerCapacitySelect} />
                {this.state.selectedAbsorptionDryerPresures !== "0" &&
                    <DropDownWhiteStyle items={this.state.absorptionDryerTemperatures} placeholder="دما (برحسب °C)" onItemSelect={this.handleAbsorptionDryerTemperatureSelect} />
                }
                {this.state.selectedAbsorptionDryerTempreture !== "0" &&
                    <div className="row">
                        <form onSubmit={this.handleSubmit} action="/">
                            <div className="mb-4 mt-3">
                                {this.renderInput("InletFlowRate", "", "نرخ جریان ورودی", "text", "form-control form-control-lg", "true")}
                            </div>
                            <h6>نرخ جریان ورودی بر حسب نرمال متر مکعب Nm³/h</h6>
                            <div className="d-grid mb-4">
                                {this.renderButton("یافتن مدل مناسب")}
                            </div>
                            {this.state.suggestedModel !== "" &&
                                <Fragment>
                                    <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                                    <div className="modelheadbox">
                                        <h1 >{this.state.suggestedModel}</h1>
                                        <hr className="divider" />
                                    </div>
                                    <div className="row hrow mt-4">
                                        <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                                    </div>
                                </Fragment>
                            }
                        </form>
                    </div>
                }
            </section>
        );
    }
}
